// extracted by mini-css-extract-plugin
module.exports = {"table_wrapper":"Table_table_wrapper__XLjuK","table_scroll":"Table_table_scroll__8p0wu"};